import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/LogoWeb.png'


const _withScopeId = n => (_pushScopeId("data-v-5b435299"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-w-full tw-h-screen tw-overflow-hidden" }
const _hoisted_2 = { class: "sm:tw-max-w-sm tw-w-full tw-ml-auto lg:tw-mr-32 tw-h-full tw-flex tw-justify-center tw-items-center tw-px-2" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "tw-py-4" }, "Iniciar Sesion", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_5 = { class: "p-fluid tw-space-y-4" }
const _hoisted_6 = { class: "p-inputgroup user-group" }
const _hoisted_7 = { class: "p-field" }
const _hoisted_8 = { class: "tw-w-full tw-text-sm tw-text-red-500" }
const _hoisted_9 = { class: "tw-space-y-2" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-mt-4 tw-flex tw-items-center tw-justify-center" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://globalapp.ar",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      alt: "logo",
      src: _imports_0,
      style: {"height":"2.5em"}
    })
  ])
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-w-full" }, null, -1))
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 0,
  class: "tw-w-full"
}
const _hoisted_15 = { class: "tw-p-3" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-rounded-lg tw-border tw-border-blue-300 tw-bg-blue-50 tw-p-4" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "tw-text-lg tw-font-semibold tw-mb-2" }, "Requisitos para acceder al portal"),
  /*#__PURE__*/_createElementVNode("p", { class: "tw-mb-3" }, "Para utilizar este servicio, usted debe haberse atendido previamente en nuestra institución."),
  /*#__PURE__*/_createElementVNode("h4", { class: "tw-font-medium tw-mb-2" }, "Instrucciones de acceso:"),
  /*#__PURE__*/_createElementVNode("ol", { class: "tw-pl-5 tw-mb-3 tw-list-disc" }, [
    /*#__PURE__*/_createElementVNode("li", null, "Seleccione su tipo de documento e ingrese su número"),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode("Use como contraseña temporal su "),
      /*#__PURE__*/_createElementVNode("span", { class: "tw-font-medium" }, "año de nacimiento"),
      /*#__PURE__*/_createTextVNode(" (por ejemplo: 1985)")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "tw-text-sm tw-italic tw-text-gray-600" }, "Al ingresar por primera vez, el sistema le solicitará crear una contraseña personalizada.")
], -1))
const _hoisted_17 = { class: "tw-mt-4 tw-border-blue-300 tw-rounded-lg tw-p-3 tw-text-center" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tw-font-medium tw-text-blue-600" }, "¿Nunca se ha atendido en nuestra institución?", -1))
const _hoisted_19 = {
  key: 1,
  class: "tw-w-full"
}
const _hoisted_20 = { class: "tw-w-full tw-space-y-4" }
const _hoisted_21 = { class: "p-inputgroup tw-space-x-2" }
const _hoisted_22 = { class: "p-inputgroup user-group" }
const _hoisted_23 = { class: "p-inputgroup tw-space-x-2" }
const _hoisted_24 = { class: "p-inputgroup" }
const _hoisted_25 = { class: "p-inputgroup" }
const _hoisted_26 = { class: "p-inputgroup" }
const _hoisted_27 = { class: "p-inputgroup" }
const _hoisted_28 = {
  key: 0,
  class: "p-inputgroup"
}
const _hoisted_29 = {
  key: 1,
  class: "p-inputgroup"
}
const _hoisted_30 = {
  key: 2,
  class: "p-inputgroup"
}
const _hoisted_31 = { class: "tw-w-full tw-text-center" }
const _hoisted_32 = { class: "tw-text-red-500 tw-text-sm" }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { class: "tw-text-center tw-w-full!" }
const _hoisted_35 = { class: "tw-w-full! tw-flex tw-justify-center tw-items-center tw-py-4 tw-space-x-2" }
const _hoisted_36 = { class: "tw-text-center" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = /*#__PURE__*/_createTextVNode("Volver a enviar en: ")
const _hoisted_39 = { class: "tw-w-full" }
const _hoisted_40 = { class: "tw-text-red-500 tw-text-sm" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-w-full" }, null, -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-w-full tw-pb-4" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Recuperacion de contraseña")
  ])
], -1))
const _hoisted_43 = {
  key: 0,
  class: "tw-w-full! tw-p-4"
}
const _hoisted_44 = { class: "tw-text-center tw-w-full!" }
const _hoisted_45 = { class: "tw-w-full! tw-flex tw-justify-center tw-items-center tw-py-4 tw-space-x-2" }
const _hoisted_46 = { class: "tw-text-center" }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = /*#__PURE__*/_createTextVNode("Volver a enviar en: ")
const _hoisted_49 = {
  key: 1,
  class: "tw-w-full! tw-flex tw-flex-col tw-justify-center tw-items-center tw-space-y-2 tw-p-4"
}
const _hoisted_50 = { class: "tw-flex tw-flex-col lg:tw-flex-row tw-justify-center tw-items-center lg:tw-space-x-2 lg:tw-space-y-0 tw-space-y-2" }
const _hoisted_51 = { class: "tw-text-sm tw-text-red-500" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-w-full" }, null, -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-flex tw-flex-col tw-gap-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "tw-w-full" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "tw-font-semibold tw-text-xl" }, "Solicitud Exitosa")
  ]),
  /*#__PURE__*/_createElementVNode("hr"),
  /*#__PURE__*/_createElementVNode("div", { class: "px-4 tw-flex tw-flex-col tw-gap-4 tw-text-justify tw-max-w-lg" }, [
    /*#__PURE__*/_createElementVNode("p", null, "Sus datos quedaron registrados, recibira un correo electronico informando el momento para poder comenzar a operar."),
    /*#__PURE__*/_createElementVNode("span", null, "Muchas Gracias.")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Password = _resolveComponent("Password")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      style: _normalizeStyle(`background-image:url(${_ctx.BackgroundImage})`),
      class: "login tw-bg-gray-200"
    }, [
      _createVNode(_component_Toast, { position: "bottom-right" }),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Card, {
            class: _normalizeClass(["p-shadow-24 tw-bg-gray-50 tw-p-4 tw-pb-0 tw-pt-0 tw-w-full tw-mt-10", {"animacion": _ctx.animated, "animate" : !_ctx.animated }])
          }, {
            title: _withCtx(() => [
              _hoisted_3,
              _hoisted_4
            ]),
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_Dropdown, {
                    class: "",
                    modelValue: _ctx.tipoDni,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tipoDni) = $event)),
                    maxlength: "10",
                    options: _ctx.tiposDNI
                  }, null, 8, ["modelValue", "options"]),
                  _createVNode(_component_InputText, {
                    onKeyup: _withKeys(_ctx.handleClick, ["enter"]),
                    onInput: _ctx.handleChangeUser,
                    placeholder: "Numero de documento",
                    modelValue: _ctx.user,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user) = $event))
                  }, null, 8, ["onKeyup", "onInput", "modelValue"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_Password, {
                    onKeyup: _withKeys(_ctx.handleClick, ["enter"]),
                    placeholder: "Contraseña",
                    toggleMask: "",
                    feedback: false,
                    modelValue: _ctx.pass,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pass) = $event))
                  }, null, 8, ["onKeyup", "modelValue"])
                ]),
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.error), 1)
              ])
            ]),
            footer: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_Button, {
                  loading: _ctx.isLoad,
                  label: "Ingresar",
                  class: "tw-w-full",
                  onClick: _ctx.handleClick
                }, null, 8, ["loading", "onClick"]),
                _createVNode(_component_Button, {
                  label: "Olvide mi contraseña",
                  class: "p-button-link",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handlePassRecoverClick(true)))
                }),
                _hoisted_10,
                _createVNode(_component_Button, {
                  label: "Primera Vez",
                  class: "tw-w-full p-button-outlined p-button-info",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleNuevoUsuarioClick(true)))
                })
              ]),
              _hoisted_11
            ]),
            _: 1
          }, 8, ["class"])
        ])
      ])
    ], 4),
    _createVNode(_component_Dialog, {
      onHide: _cache[23] || (_cache[23] = ($event: any) => (_ctx.handleNuevoUsuarioClick(false))),
      visible: _ctx.ModalDisplay,
      "onUpdate:visible": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.ModalDisplay) = $event)),
      modal: true,
      style: {'max-width': '100vw'},
      class: "tw-rounded-lg!"
    }, {
      header: _withCtx(() => [
        _hoisted_12
      ]),
      footer: _withCtx(() => [
        (_ctx.isModoRegistro || _ctx.isModoEsperarCodigo)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              label: "Aceptar",
              onClick: _cache[21] || (_cache[21] = () => _ctx.isModoEsperarCodigo ? _ctx.onAceptarCodigoClick() : _ctx.onAceptarClick()),
              class: "p-button-primary"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_Button, {
          label: "Salir",
          class: "tw-px-8 p-button-link",
          onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.handleNuevoUsuarioClick(false)))
        })
      ]),
      default: _withCtx(() => [
        (!_ctx.isModoEsperarCodigo)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              (!_ctx.isModoRegistro)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _createElementVNode("div", _hoisted_17, [
                        _hoisted_18,
                        _createVNode(_component_Button, {
                          label: "Solicite un registro como paciente",
                          class: "p-button-info tw-mt-4",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isModoRegistro = true))
                        })
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_InputText, {
                          placeholder: "Nombre",
                          modelValue: _ctx.nuevoUserNombre,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.nuevoUserNombre) = $event))
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_InputText, {
                          placeholder: "Apellido",
                          modelValue: _ctx.nuevoUserApellido,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.nuevoUserApellido) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_Dropdown, {
                          class: "dropdown",
                          modelValue: _ctx.tipoDni,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.tipoDni) = $event)),
                          maxlength: "10",
                          options: _ctx.tiposDNI
                        }, null, 8, ["modelValue", "options"]),
                        _createVNode(_component_InputText, {
                          placeholder: "Numero de documento",
                          modelValue: _ctx.nuevoUserDocumento,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.nuevoUserDocumento) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(_component_Calendar, {
                          placeholder: "Fecha de nacimiento",
                          modelValue: _ctx.nuevoUserFechaNacimiento,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.nuevoUserFechaNacimiento) = $event))
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_Dropdown, {
                          modelValue: _ctx.nuevoUserSexo,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.nuevoUserSexo) = $event)),
                          maxlength: "10",
                          options: ['Masculino','Femenino'],
                          placeholder: "Sexo"
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _createVNode(_component_InputText, {
                          placeholder: "Email",
                          type: "email",
                          modelValue: _ctx.nuevoUserEmail,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.nuevoUserEmail) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(_component_InputText, {
                          placeholder: "Direccion",
                          modelValue: _ctx.nuevoUserDireccion,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.nuevoUserDireccion) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(_component_InputText, {
                          placeholder: "Telefono",
                          type: "tel",
                          modelValue: _ctx.nuevoUserTelefono,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.nuevoUserTelefono) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createVNode(_component_Dropdown, {
                          optionLabel: "nombre",
                          options: _ctx.coberturas,
                          onChange: _ctx.onCoberturaChanged,
                          modelValue: _ctx.nuevoUserCobertura,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.nuevoUserCobertura) = $event)),
                          placeholder: "Cobertura"
                        }, null, 8, ["options", "onChange", "modelValue"])
                      ]),
                      (_ctx.nuevoUserCobertura && _ctx.nuevoUserCobertura.nombre.toLowerCase() !== "particular")
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            _createVNode(_component_Dropdown, {
                              onChange: _ctx.onPlanesChanged,
                              options: _ctx.planesCoberturas,
                              optionLabel: "nombre",
                              modelValue: _ctx.nuevoUserPlan,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.nuevoUserPlan) = $event)),
                              placeholder: "Plan"
                            }, null, 8, ["onChange", "options", "modelValue"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.nuevoUserCobertura && _ctx.nuevoUserCobertura.nombre.toLowerCase() !== "particular")
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                            _createVNode(_component_Dropdown, {
                              options: _ctx.planesCondicionIva,
                              optionLabel: "label",
                              modelValue: _ctx.nuevoUserCondicionIva,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.nuevoUserCondicionIva) = $event)),
                              placeholder: "Condicion Iva"
                            }, null, 8, ["options", "modelValue"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.nuevoUserCobertura && _ctx.nuevoUserCobertura.nombre.toLowerCase() !== "particular")
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                            _createVNode(_component_InputText, {
                              placeholder: "Credencial",
                              modelValue: _ctx.nuevoUserCarnetCobertura,
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.nuevoUserCarnetCobertura) = $event))
                            }, null, 8, ["modelValue"])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.errorNuevoUsuario), 1)
                      ])
                    ])
                  ]))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("span", null, "Se ha enviado un código a la direccion de correo: " + _toDisplayString(_ctx.nuevoUserEmail), 1)
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createVNode(_component_InputText, {
                  size: "large",
                  placeholder: "Ingrese el codigo.",
                  modelValue: _ctx.codigoDeRecuperacion,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.codigoDeRecuperacion) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_36, [
                (_ctx.time.asSeconds() > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_37, [
                      _hoisted_38,
                      _createElementVNode("span", null, _toDisplayString(`${_ctx.time.minutes()}`.padStart(2,'00')) + ":" + _toDisplayString(`${_ctx.time.seconds()}`.padStart(2,'00')), 1)
                    ]))
                  : (_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      label: "Reenviar Codigo",
                      class: "p-button-primary p-button-link tw-px-8",
                      onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.onAceptarClick()))
                    }))
              ]),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.errorNuevoUsuario), 1)
              ])
            ]))
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      onHide: _cache[30] || (_cache[30] = ($event: any) => (_ctx.handlePassRecoverClick(false))),
      visible: _ctx.ModalPassRecover,
      "onUpdate:visible": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.ModalPassRecover) = $event)),
      modal: true,
      style: {"max-width":"100vw"}
    }, {
      header: _withCtx(() => [
        _hoisted_41
      ]),
      footer: _withCtx(() => [
        (_ctx.isCodeValid)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              label: "Guardar",
              class: "p-button-primary tw-px-8",
              onClick: _ctx.cambioDePass
            }, null, 8, ["onClick"]))
          : (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              disabled: _ctx.codigoDeRecuperacion.length < 5,
              label: "Aceptar",
              class: "p-button-primary tw-px-8",
              onClick: _ctx.handleEnviarCodigo
            }, null, 8, ["disabled", "onClick"])),
        _createVNode(_component_Button, {
          label: "Salir",
          class: "p-button-primary p-button-link tw-px-8",
          onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.handlePassRecoverClick(false)))
        })
      ]),
      default: _withCtx(() => [
        _hoisted_42,
        (!_ctx.isCodeValid)
          ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("span", null, "Se ha enviado un código a la direccion de correo: " + _toDisplayString(_ctx.emailDeRecuperacion), 1)
              ]),
              _createElementVNode("div", _hoisted_45, [
                _createVNode(_component_InputText, {
                  size: "large",
                  placeholder: "Ingrese el codigo.",
                  modelValue: _ctx.codigoDeRecuperacion,
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.codigoDeRecuperacion) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_46, [
                (_ctx.time.asSeconds() > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_47, [
                      _hoisted_48,
                      _createElementVNode("span", null, _toDisplayString(`${_ctx.time.minutes()}`.padStart(2,'00')) + ":" + _toDisplayString(`${_ctx.time.seconds()}`.padStart(2,'00')), 1)
                    ]))
                  : (_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      label: "Reenviar Codigo",
                      class: "p-button-primary p-button-link tw-px-8",
                      onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.handlePassRecoverClick(true)))
                    }))
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, [
                _createVNode(_component_Password, {
                  placeholder: "Nueva Contraseña",
                  toggleMask: "",
                  feedback: false,
                  modelValue: _ctx.pass,
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.pass) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_Password, {
                  placeholder: "Repita la Contraseña",
                  toggleMask: "",
                  feedback: false,
                  modelValue: _ctx.passRepeat,
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.passRepeat) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.error), 1)
            ]))
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.showSolicitudExitosa,
      "onUpdate:visible": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.showSolicitudExitosa) = $event)),
      modal: true,
      style: {"max-width":"100vw"}
    }, {
      header: _withCtx(() => [
        _hoisted_52
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Aceptar",
          class: "p-button-primary tw-px-8",
          onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.showSolicitudExitosa = false))
        })
      ]),
      default: _withCtx(() => [
        _hoisted_53
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}